<template>
  <div  v-show="isShow" class="middle-container">
    <img class="qr-bg" id="img" src="http://img.elongstatic.com/middle-code.png" @click="jump" mode="widthFix"/>
    <div class="text">点击进入赏金小助手，领取红包</div>
    <img
			class="btn-click"
			src="http://m.elongstatic.com/mall-v2/goXCX.png"
            @click="jump"
		/>
  </div>
</template>

<script>
import {
    applyfortokenQywx,
    getTokenApi,
    getScheme,
} from '../service/api';
import { Toast } from 'vant';
export default {
    data(){
        return {
            isShow:false,
            currentId:'',
        }
    },
    async created(){
        document.title = '语音红包'
        const str = location.hash.split('?').pop();
        const arr = str.split('&');
        const param = {};
        arr.forEach(v => {
            const array = v.split('=');
            if(array && array.length) param[array[0]] = array[1];
        })
        const { code,id} = param;
        if(id){
            this.currentId=id
        }
        if(!code){
            this.applyfortokenFn()
        }
        if(code&& !this.checkLogin()){
            await this.getTokenApiFn(code);
        }
    },
    mounted(){
        const img=document.getElementById('img')
        if(img){
           img.addEventListener("load", this.loadImgHandler)
        }
        const ua= window.navigator.userAgent.toLowerCase();
        if((ua.match(/MicroMessenger/i) == 'micromessenger') && (ua.match(/wxwork/i) == 'wxwork') ){
                        //   alert("企业微信客户端");
        }else if(ua.match(/micromessenger/i) == 'micromessenger' ){
                    this.$toast({
                    message: `<div style="height:4rem;display:flex;justify-content: center;align-items: center;border-radius:2rem;"><span style="font-size:1rem">请使用企业微信扫码</span></div>`,
                    type: 'html'
                });
        }
    },
    methods:{
        loadImgHandler(){
            this.isShow=true
        },
        // 检查是否登录
        checkLogin(){
            return localStorage.getItem('access_token');
        },
       // 获取统一登录链接
       applyfortokenFn(){
        console.log(location.href);
        // http://yearwish.17usoft.com/#/middle
        // http://yearwish.qa1.17usoft.com/#/middle?id=2301060000383
        // http://localhost:8080/#/middle?id=2301060000383
        let redirectUrl=encodeURIComponent(`http://yearwishmobile.17usoft.com/#/middle?id=${this.currentId}`)
        if(this.currentId){
           redirectUrl=encodeURIComponent(`http://yearwishmobile.17usoft.com/#/middle?id=${this.currentId}`)
        }else{
            redirectUrl=encodeURIComponent(location.href)
        }
        applyfortokenQywx(redirectUrl).then(res => {
                    if(res.code === '0'){
                        location.href = res.data;
                    }else{
                        Toast.fail(res.msg);
                    }
                })
        },
        // 获取token
        getTokenApiFn(code){
            return new Promise(resolve => {
                // console.log(code, state);
                const param = {
                    code,
                    state:''
                }
                getTokenApi(param).then(res => {
                    if(res.code === '0'){
                        if(!res.data){
                            localStorage.removeItem('access_token');
                            localStorage.removeItem('isAutoDialog')
                            router.replace({
                                path: '/blank',
                            });
                            return
                        }
                        // 设置token
                        localStorage.setItem('access_token', res.data)
                    }else{
                        Toast.fail(res.msg);
                    }
                    resolve();
                })
            });
        },
        // 点击跳转到小程序页面进行抽奖
        jump(){
            if(!this.checkLogin()){
                this.applyfortokenFn()
                return
            }
            const param = {
                path:"pages/lottery/draw-lottery/draw-lottery",
                query:`id=${this.currentId}&access_token=${this.checkLogin()}&fromToca=QYWX`,
                business: '600000',
                templateId: 589,
                envVersion:'trial'
            }
            getScheme(param).then(res => {
                if(res.code === '0' && res.data){
                    console.log('--------获取scheme');
                    console.log(res);
                    // 跳到小程序的页面。
                    location.href = res.data;
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.middle-container{
    background-color: #EC4236;
    // background-color: aqua;
    width:100vw;
    height:100vh;
    position: relative;
    display: flex;
    align-items: center;
}
.qr-bg{
    width:100%;   
    margin-top:-8rem;
}
.btn-click {
    animation: luckyBageShake 1s infinite;
    /* width: 100%; */
    position: absolute;
    left: 50%;
    top: 56%;
    cursor: pointer;
    display: flex;
    width:120px !important;
    height:84px !important;
    justify-content: center;
    transform: translate(-50%,-50%);
}
@keyframes luckyBageShake {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.2);
    }

    100% {
        transform: scale(1);
    }
}
.text{
    width:100%;
    position: absolute;
    font-size: 30px;
    color:#FBE5B4;
    top:85%;
    text-align: center;
}

</style>